import Swal from "sweetalert2";
import firebase from "../config/global-variables";

//GET USERS CONNECTIONS
export const getUsersConnections = async (searchText, idCompany, uid, type, initDate, endDate) => {
  try {
    const url = `https://us-central1-${firebase.nameProyectFirebase}.cloudfunctions.net/app/api/getUsersConnections`;
    const optionsRequest = {
      timeout: 10000,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        companyID: idCompany,
        managerID: uid,
        typeUser: type,
        email: searchText,
        initDate: initDate,
        endDate: endDate
      }),
      //mode:'no-cors'
    };

    const response = await fetch(url, optionsRequest);
    const data = await response.json();
    // Assuming the API response has a top-level property named 'Data' containing the array of connections
    return data.Data || [];
  } catch (error) {
    console.error("Error al obtener las conexiones de usuarios:", error);

    const mensaje = String(error);
    if (mensaje.trim().toUpperCase() === 'TYPEERROR: FAILED TO FETCH') {
      swalMessagepop('Se ha perdido la conexión');
    } 
    else 
    {
      swalMessagepop("Error al obtener la información de conexiones de usuarios. Inténtelo más tarde.");
    }
    
    return [];
  }
};

const swalMessagepop = (message = "") => {
  Swal.fire({
    title: "Advertencia",
    text: message,
    icon: "warning",
    confirmButtonText: "Ok",
  });
};